module.exports = __webpack_public_path__ + "static/media/value-creator.23dacf93.jpg";